module.exports = __webpack_public_path__ + "4f1f7e40af06d4c11500b675921ff7f5.jpg";